'use client'

import { useState } from 'react'

import { LazyMobileMenu } from './LazyMobileMenu'
import { TMobileMenuProps } from './MobileMenu'
import { MobileMenuTrigger } from './MobileMenuTrigger'

type TLazyMobileMenuWithFallbackProps = Omit<
	TMobileMenuProps,
	'isOpen' | 'setIsOpen'
>

export const LazyMobileMenuWithFallback = (
	props: TLazyMobileMenuWithFallbackProps,
) => {
	const [isOpen, setIsOpen] = useState(false)
	const [hasLoaded, setHasLoaded] = useState(false)

	return (
		<div>
			{!hasLoaded ? (
				<MobileMenuTrigger onPointerDown={() => setIsOpen(true)} />
			) : null}
			<LazyMobileMenu
				{...props}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				setHasLoaded={setHasLoaded}
			/>
		</div>
	)
}
